
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryVertical75 as ObiBatteryVertical75Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-vertical-75.js';
 
 
 

 
 export const ObiBatteryVertical75 = createComponent({
   react: React,
   tagName: 'obi-battery-vertical-75',
   elementClass: ObiBatteryVertical75Element,
   events: {
     
   }
  });
 
 